var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "100px",
          "search-btn-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("InternalOrder.form.ERPCard"),
                                  prop: "erpOrderTime",
                                },
                              },
                              [
                                _c("el-input-number", {
                                  staticClass: "full-width",
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    placeholder: _vm.$t("inputText"),
                                    min: 0,
                                    precision: 0,
                                    controls: false,
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.handleQuery.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.queryParams.erpOrderTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "erpOrderTime",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.erpOrderTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("InternalOrder.form.SAPCard"),
                                  prop: "sapOrderTime",
                                },
                              },
                              [
                                _c("el-input-number", {
                                  staticClass: "full-width",
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    placeholder: _vm.$t("inputText"),
                                    min: 0,
                                    precision: 0,
                                    controls: false,
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.handleQuery.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.queryParams.sapOrderTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "sapOrderTime",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.sapOrderTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("InternalOrder.form.HJCard"),
                                  prop: "hjOrderTime",
                                },
                              },
                              [
                                _c("el-input-number", {
                                  staticClass: "full-width",
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    placeholder: _vm.$t("inputText"),
                                    min: 0,
                                    precision: 0,
                                    controls: false,
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.handleQuery.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.queryParams.hjOrderTime,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "hjOrderTime",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.hjOrderTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("InternalOrder.number"),
                                  prop: "orderNo",
                                },
                              },
                              [
                                _c("BjInput", {
                                  staticStyle: { height: "1px!important" },
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                                    placeholder: _vm.$t("inputText"),
                                    clearable: "",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.handleQuery.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.queryParams.orderNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParams, "orderNo", $$v)
                                    },
                                    expression: "queryParams.orderNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("BjSelectChannelStore", {
                          attrs: {
                            span: _vm.colSpan,
                            "query-params": _vm.queryParams,
                            "query-props": ["channel", "storeIdList"],
                            multiple: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "beforeSearchBtn",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 24 - _vm.colSpan } },
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: {
                          value: _vm.queryParamsTradeStatus,
                          type: "card",
                        },
                        on: { "tab-click": _vm.handleTabClick },
                      },
                      [
                        _c("el-tab-pane", {
                          key: "erp",
                          attrs: {
                            label: _vm.$t("InternalOrder.ERP"),
                            name: "erp",
                          },
                        }),
                        _c("el-tab-pane", {
                          key: "sap",
                          attrs: {
                            label: _vm.$t("InternalOrder.SAP"),
                            name: "sap",
                          },
                        }),
                        _c("el-tab-pane", {
                          key: "wms",
                          attrs: {
                            label: _vm.$t("InternalOrder.WMS"),
                            name: "wms",
                          },
                        }),
                        _c("el-tab-pane", {
                          key: "xxx",
                          attrs: {
                            label: _vm.$t("InternalOrder.form.tab"),
                            name: "xxx",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onExport },
                      },
                      [_vm._v(_vm._s(_vm.$t("exportText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$toBusinessThirdOrderView(
                                                    scope.row.outerOrderNo,
                                                    false,
                                                    _vm.businessType
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.webReference)
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.webReference,
                                            },
                                          }),
                                        ]
                                      : col.prop === "innerOrderNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$toBusinessOrderInternalView(
                                                    scope.row.innerOrderNo,
                                                    false,
                                                    _vm.businessType
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "orderStatusStr"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] ===
                                                  "Proccessing"
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "orderTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "creationDate"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "sapPushTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "sapPullTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "hjPushTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "hjLockTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "hjShipmentTime"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeOptimization")(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "exceptionReason"
                                      ? [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row[col.prop])),
                                          ]),
                                        ]
                                      : col.prop === "tags"
                                      ? [
                                          scope.row.tags
                                            ? _c("BjTagList", {
                                                attrs: {
                                                  "tag-code-array":
                                                    scope.row.tags.split(","),
                                                  size: "mini",
                                                  circle: "",
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      : col.prop === "goodsQuatity"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onSkuDetail(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "totalAmount" ||
                                        col.prop === "buyerPay" ||
                                        col.prop === "costPrice"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$number2money(
                                                  scope.row[col.prop]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "deliveryStatus"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] ===
                                                  "30512"
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.ORDER_INTERNAL_DELIVER_STATUS_LIST.bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "receivingStatus"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] ===
                                                  "30522"
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_RECEIVING_STATUS_LIST.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "stockFlag"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.STATUS_YES_NUM.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "isGift"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: scope.row[col.prop]
                                                  ? "success"
                                                  : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.STATUS_HAVE_TRUE.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "actionType"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_ACTION_TYPE_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "businessType"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_BUSINESS_TYPE_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "takingDeliveryWay"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.ORDER_TAKING_DELIVERY_TYPE_LIST.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "preemptionStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_PREEMPT_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "syncPreempStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_PREEMPT_BACK_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "sourceStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_SOURCE_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "suspendStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_HAND_UP_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "syncDeliveryStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_INTERNAL_STOCK_BACK_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : Object.keys(
                                          _vm.ORDER_DECRYPT_NAME
                                        ).includes(col.prop)
                                      ? [
                                          _c("BjDecrypt", {
                                            attrs: {
                                              row: scope.row,
                                              "row-key": col.prop,
                                              channel: scope.row.channel,
                                              type: _vm.ORDER_DECRYPT_NAME[
                                                col.prop
                                              ],
                                              "order-sn":
                                                scope.row.outerOrderNo,
                                              copy:
                                                col.prop ===
                                                "receiverPhoneMask",
                                            },
                                          }),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.goodsInfoTab.title,
            visible: _vm.goodsInfoTab.visible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.goodsInfoTab, "visible", $event)
            },
          },
        },
        [
          _c("GoodsInfoTab", {
            attrs: {
              "order-id": _vm.goodsInfoTab.orderId,
              "business-type": _vm.businessType,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }